import { GenderEnum } from 'app/models';

export class GenderModel {
    public static GenderList: Array<any> = [
        { name: 'Male', value: GenderEnum.Male },
        { name: 'Female', value: GenderEnum.Female },
        { name: 'Prefer Not to Say', value: GenderEnum.PreferNotToSay }
    ];
}
